export default "__VITE_ASSET__CEQLMoSu__"